import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthDebugPage() {
  const [debugInfo, setDebugInfo] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const info = {
      fullUrl: window.location.href,
      origin: window.location.origin,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      searchParams: {},
      hashParams: {}
    };

    // Parse search params
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach((value, key) => {
      info.searchParams[key] = value;
    });

    // Parse hash params
    if (window.location.hash) {
      const hashString = window.location.hash.substring(1); // Remove #
      const hashParams = new URLSearchParams(hashString);
      hashParams.forEach((value, key) => {
        info.hashParams[key] = value;
      });
    }

    setDebugInfo(info);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold mb-6 text-gray-900">Auth Debug Information</h1>
        
        <div className="space-y-4">
          <div className="bg-blue-50 p-4 rounded">
            <h2 className="font-bold text-lg mb-2">Full URL</h2>
            <p className="text-sm break-all font-mono">{debugInfo.fullUrl}</p>
          </div>

          <div className="bg-green-50 p-4 rounded">
            <h2 className="font-bold text-lg mb-2">Search (Query) Parameters</h2>
            <pre className="text-sm">{JSON.stringify(debugInfo.searchParams, null, 2)}</pre>
          </div>

          <div className="bg-yellow-50 p-4 rounded">
            <h2 className="font-bold text-lg mb-2">Hash Fragment Parameters</h2>
            <pre className="text-sm">{JSON.stringify(debugInfo.hashParams, null, 2)}</pre>
          </div>

          <div className="bg-purple-50 p-4 rounded">
            <h2 className="font-bold text-lg mb-2">All URL Parts</h2>
            <pre className="text-sm">{JSON.stringify({
              origin: debugInfo.origin,
              pathname: debugInfo.pathname,
              search: debugInfo.search,
              hash: debugInfo.hash
            }, null, 2)}</pre>
          </div>
        </div>

        <button
          onClick={() => navigate("/")}
          className="mt-6 bg-emerald-600 text-white px-6 py-2 rounded hover:bg-emerald-700"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
